import { render } from "@/components/pages/individualWorkSupport/requirement038/Requirement038.html?vue&type=template&id=061bc0f4&scoped=true&external"
import script from "@/components/pages/individualWorkSupport/requirement038/Requirement038.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualWorkSupport/requirement038/Requirement038.js?vue&type=script&lang=js&external"

import "@/components/pages/individualWorkSupport/requirement038/Requirement038.scss?vue&type=style&index=0&id=061bc0f4&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061bc0f4"]])

export default __exports__